import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const VideoSection = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showOverlay, setShowOverlay] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    nombre: "",
    telefono: "",
    email: "",
    objetivo: "",
  });
  const [backgroundImage, setBackgroundImage] = useState(
    "https://celebratufiesta.com.co/wp-content/uploads/2025/06/Banner-pagina-emora-2.png"
  );

  const navigate = useNavigate();
  const goToHome = () => navigate("/");
  const goToBlog = () => navigate("/blogernesto");

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const handleOverlayClick = () => setShowOverlay(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Información enviada correctamente.");
    setShowForm(false);
  };

  const closeForm = () => setShowForm(false);

  useEffect(() => {
    const updateBackground = () => {
      if (window.innerWidth < 770) {
        setBackgroundImage(
          "https://celebratufiesta.com.co/wp-content/uploads/2025/06/Banner-pagina-emora-2.png"
        );
      } else {
        setBackgroundImage(
          "https://celebratufiesta.com.co/wp-content/uploads/2025/04/IMAGENDE-1-2.png"
        );
      }
    };

    updateBackground();
    window.addEventListener("resize", updateBackground);
    return () => window.removeEventListener("resize", updateBackground);
  }, []);

  return (
    <div
      className="relative flex flex-col items-center justify-center min-h-[75vh] bg-cover bg-center text-white"
      style={{ backgroundImage: `url('${backgroundImage}')` }}
    >
      {/* Botones arriba a la izquierda */}
      <div className="absolute top-4 left-4 flex gap-4 z-50">
       
        <button
          onClick={goToBlog}
          className="bg-[#FFD700] text-black px-4 py-2 rounded-full font-bold shadow-lg hover:bg-yellow-400"
        >
          BLOG
        </button>
      </div>

      {/* Botón de contacto */}
      <button
        className={`absolute ${
          window.innerWidth < 400
            ? "top-2 right-2 text-sm px-2 py-1"
            : "top-4 right-4 text-base px-4 py-2"
        } bg-red-600 hover:bg-red-700 text-white font-bold rounded-lg shadow-md transition`}
        onClick={() => setShowForm(true)}
      >
        Contrata / Contacta A Ernesto
      </button>

{/* Firma para pantallas grandes - centrada */}
<div className="hidden lg:block mb-12 text-center">
  <img
    src="https://celebratufiesta.com.co/wp-content/uploads/2025/01/firma.png"
    alt="Firma Ernesto Mora"
    className="mx-auto h-48 w-auto"
  />
</div>

{/* Firma para pantallas pequeñas - bien a la derecha */}
<div className="block lg:hidden mt-4 w-full flex justify-end pr-6">
  <img
    src="https://celebratufiesta.com.co/wp-content/uploads/2025/01/firma.png"
    alt="Firma Ernesto Mora"
    className="h-20 w-auto opacity-90"
  />
</div>

<div className="text-center mb-12 bg-black bg-opacity-50 p-4 rounded-lg">
  <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl italic font-semibold text-white">
    "DONDE OTROS VEN RIESGO, <br />YO VEO OPORTUNIDAD DE INNOVACIÓN."
  </p>
</div>



      {/* Video modal */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
          <div className="bg-black relative max-w-4xl w-full">
            <div
              className="relative w-full h-0"
              style={{ paddingBottom: "56.25%" }}
            >
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/OHlUknpkGnQ?autoplay=1&mute=1"
                title="YouTube video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            {showOverlay && (
              <div
                onClick={handleOverlayClick}
                className="absolute inset-0 bg-gradient-to-r from-[#FFD700] via-[#FFC700] to-[#FFB800] bg-opacity-90 flex flex-col items-center justify-center cursor-pointer"
              >
                <p className="text-black font-bold text-xl mb-2">
                  ACTIVA EL SONIDO
                </p>
                <p className="text-black text-lg">TOCANDO AQUÍ</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-12 w-12 mt-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </div>
            )}
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-full p-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      )}

      {/* Formulario de contacto */}
      {showForm && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          onClick={closeForm}
        >
          <div
            className="bg-white p-6 bg-gradient-to-r from-[#FFD700] via-[#FFC700] to-[#FFB800] text-black font-bold rounded-lg w-full max-w-md"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-2xl font-bold mb-4">Formulario de Contacto</h2>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block text-gray-700">Nombre*</label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleInputChange}
                  required
                  className="w-full border border-gray-300 rounded px-3 py-2"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">Teléfono*</label>
                <input
                  type="text"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleInputChange}
                  required
                  className="w-full border border-gray-300 rounded px-3 py-2"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">E-mail*</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full border border-gray-300 rounded px-3 py-2"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">
                  ¿Con qué objetivo quieres contratar a Ernesto?*
                </label>
                <textarea
                  name="objetivo"
                  value={formData.objetivo}
                  onChange={handleInputChange}
                  required
                  className="w-full border border-gray-300 rounded px-3 py-2"
                ></textarea>
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={closeForm}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded mr-2"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-green-600 text-white rounded"
                >
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoSection;
